export { default } from './OptionSlideCard';
